import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Auth } from '@freelancer/auth';
import { LoginConfig, LOGIN_CONFIG } from '@freelancer/login';
import { map } from 'rxjs/operators';
import { ShellConfig } from './shell-config.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedOutRestrictedGuard implements CanActivate {
  constructor(
    @Inject(LOGIN_CONFIG) private loginConfig: LoginConfig,
    private auth: Auth,
    private router: Router,
    private shellConfig: ShellConfig,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.isLoggedIn().pipe(
      map(isLoggedIn => {
        const config = this.shellConfig.getRecursiveRouteData(route);
        if (
          !isLoggedIn &&
          this.loginConfig.loggedOutRestricted &&
          !config.bypassLogoutRestricted
        ) {
          return this.router.createUrlTree(['/login'], {
            queryParams: {
              next: encodeURIComponent(state.url),
            },
          });
        }
        return true;
      }),
    );
  }
}
